module.exports = __webpack_public_path__ + "static/media/plumbing-photo-2.e13c2e2c.jpg";